









































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';

import { MobileGetter, Optional, User, PaywallPlansInfo, ExperimentGetter } from 'frontend/types';
import { Discount } from 'frontend/types/premium';
import ChevronSvg from 'frontend/views/premium/paywall/svgs/ChevronSvg.vue';
import BeakerAndFlaskSvg from 'frontend/views/premium/paywall/svgs/BeakerAndFlaskSvg.vue';
import RoundBottomFlask from 'frontend/views/premium/paywall/svgs/RoundBottomFlaskSvg.vue';
import Modal from 'frontend/components/Modal.vue';
import PaywallPlan from 'frontend/views/premium/PaywallPlan.vue';
import PaywallPlanMini from 'frontend/views/premium/components/PaywallPlanMini.vue';
import PaywallSubscriptionNotice from 'frontend/views/premium/components/PaywallSubscriptionNotice.vue';
import { shouldHideMonthlyPlansFromPaywall } from 'frontend/experiments/premium_referrals_10_2021';
import { isLegacyDirectTraffic, isLegacySeasonal } from 'frontend/utils/discounts';
import { addToCartTrack, track } from 'frontend/utils/analytics';
import { safeWindow } from 'frontend/utils/window';

@Component({
  components: {
    Modal,
    ChevronSvg,
    BeakerAndFlaskSvg,
    RoundBottomFlask,
    PaywallPlan,
    PaywallPlanMini,
    PaywallSubscriptionNotice,
  },
  computed: {
    ...mapState('globals', ['user']),
    ...mapState('paywall', ['paywall_type']),
    ...mapState('pageHeader', ['context']),
    ...mapState('premiumPurchaseInfo', ['is_discounted']),
    ...mapGetters('paywall', ['paywallPlans']),
    ...mapGetters('globals', ['inExperiment', 'discount']),
    ...mapGetters('pageHeader', ['isMobile']),
  },
})
export default class AvailablePlans extends Vue {
  private isMobile!: MobileGetter;
  private user!: User;
  private context: any;
  private showingAllPlans: boolean = false;
  private hover: boolean = false;
  private showLegal: boolean = false;
  private readonly discount!: Optional<Discount>;
  private readonly paywallPlans!: PaywallPlansInfo;
  private inExperiment!: ExperimentGetter;
  // tslint:disable-next-line:variable-name
  private is_discounted!: boolean;
  // tslint:disable-next-line:variable-name
  private paywall_type!: string;
  private useMobileStyling = false;

  private get canShowMorePlans(): boolean {
    return Object.keys(this.paywallPlans).length > 1;
  }

  private get buttonText(): string {
    return this.showingAllPlans ? 'Hide plans' : 'View more plans';
  }

  private get showSuscribeButton(): boolean {
    return this.paywall_type !== 'already_lifetime' && !this.isMobile(this.$mq);
  }

  private handleClick(): void {
    const container = document.querySelector('#plans-container');
    this.showingAllPlans = !this.showingAllPlans;
    track('ui', {
      action: 'click',
      element_type: 'button',
      element_id: this.showingAllPlans
        ? 'hid_extra_plans_on_returning_user_paywall'
        : 'viewed_more_plans_on_returning_user_paywall',
    });
    if (container) {
      if (this.showingAllPlans) {
        container.classList.add('active');
      } else {
        container.classList.remove('active');
      }
    }
  }

  private trackAddToCart(): void {
    addToCartTrack();
  }

  private handleAnnualClick() {
    if (!this.user.is_authenticated) {
      this.$store.dispatch('signupModal/signup');
    } else if (this.paywallPlans.annualPlan) {
      addToCartTrack();
      window.location.href = this.paywallPlans.annualPlan.checkout_url;
    }
  }

  private get directTrafficDiscount(): boolean {
    return isLegacyDirectTraffic(this.discount);
  }

  private get monthlyPlan() {
    if (shouldHideMonthlyPlansFromPaywall(this.context)) {
      return null;
    }
    return this.paywallPlans.monthlyPlan;
  }

  private get seasonalDiscount(): boolean {
    return isLegacySeasonal(this.discount);
  }

  private get experimentAwareTrialPlanPriceMessage(): string {
    const asterisk = this.annualPlanIncludesReferralDiscount ? '*' : '';
    return `${this.paywallPlans?.annualPlan?.display_price}${asterisk}/month after free trial (billed annually)`;
  }

  private axId(interval: string) {
    if (interval === 'lifetime') {
      return 'clicked_b2_lifetime_upgrade_chargebee';
    }
    const intervalComponent =
      interval === 'annual' ? 'annual' : interval === 'monthly' ? 'monthly' : undefined;
    return `clicked_b2_${intervalComponent}_logged_in_chargebee_nux`;
  }

  private handleMonthlyClick() {
    if (!this.user.is_authenticated) {
      this.$store.dispatch('signupModal/signup');
    } else if (this.monthlyPlan) {
      window.location.href = this.monthlyPlan.checkout_url;
    }
  }

  private handleLifetimeClick() {
    if (this.paywallPlans.lifetimePlan) {
      window.location.href = this.paywallPlans.lifetimePlan.checkout_url;
    }
  }

  private handleSubscribeNowClick(checkoutUrl: Location) {
    if (!this.user.is_authenticated) {
      this.$store.dispatch('signupModal/signup');
    } else {
      addToCartTrack();
      window.location = checkoutUrl;
    }
  }

  private get strikeThroughPrice(): string | null {
    if (
      !this.directTrafficDiscount ||
      this.discount?.is_visible ||
      this.annualPlanIncludesReferralDiscount
    ) {
      // fallback to usual behavior
      if (this.paywallPlans.annualPlan && this.paywallPlans.annualPlan.strikethrough_price) {
        return this.paywallPlans.annualPlan.strikethrough_price;
      }
    }
    return null;
  }

  private get shouldShowDiscount(): boolean {
    // Referral discount takes precedence
    if (this.annualPlanIncludesReferralDiscount) {
      return true;
    }
    if (this.seasonalDiscount) {
      return true;
    }
    if (this.directTrafficDiscount) {
      return !!this.discount?.is_visible;
    }
    return !!(
      this.is_discounted ||
      (this.paywallPlans.annualPlan && this.paywallPlans.annualPlan.strikethrough_price)
    );
  }

  private get campaignDiscountOverrideHtml(): string | null {
    if (this.seasonalDiscount) {
      return `${this.discount?.name} discount applied`;
    }
    if (this.directTrafficDiscount) {
      return 'Limited time discount applied';
    }
    return null;
  }

  private get annualPlanIncludesReferralDiscount(): boolean {
    return this.paywallPlans.annualPlan
      ? this.paywallPlans.annualPlan && this.paywallPlans.annualPlan.includes_referral_discount
      : false;
  }

  private get annualPlanIsTrialPlan(): boolean {
    return this.paywallPlans.annualPlan
      ? this.paywallPlans.annualPlan && this.paywallPlans.annualPlan.is_trial
      : false;
  }

  private onResize(): void {
    if (this.window) {
      this.useMobileStyling = document.body.clientWidth <= 770;
    }
  }

  private get window(): Optional<Window> {
    return safeWindow();
  }

  private mounted(): void {
    if (this.isMobile(this.$mq)) {
      this.useMobileStyling = true;
    } else if (this.window) {
      this.onResize();
      this.window.addEventListener('resize', this.onResize);
    }
  }

  private destroyed(): void {
    if (!this.isMobile(this.$mq) && this.window) {
      this.window.removeEventListener('resize', this.onResize);
    }
  }
}
